import Breadcrumb from './src/JsmBreadcrumb.vue'

Breadcrumb.install = (Vue) => {
  Vue.component(Breadcrumb.name, Breadcrumb)
}

export default Breadcrumb
